import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContentPipeModule } from 'src/app/services/content/content-pipe.module';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'dsr-under-maintencance',
    imports: [ContentPipeModule, NgOptimizedImage],
    templateUrl: './dsr-under-maintencance.component.html',
    styleUrl: './dsr-under-maintencance.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DsrUnderMaintencanceComponent {
  assetsUrl = environment.assets.url;

}
